import * as hasOwn from 'object.hasown';

// Pingdom's browser does not support Object.hasOwn.
// TODO: Remove this shim after replacing Pingdom with GCP Synthetic Monitoring, Pingdom is the only reason we use this polyfill for such an old feature
if (!Object.hasOwn) {
  hasOwn.shim();
}
